import { deliveryTemplateService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    loading: true,
    saving: false,
    items: {},
    filter: {},
    defaultFilter: {
      name: null,
      orderByColumn: 'name',
      orderByDescending: false
    },
    currentPage: 1,
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getAll ({ commit }) {
    return deliveryTemplateService.getAll()
      .then(
        data => {
          commit('getAllSuccess', data.result)
          return data.result
        }
      )
  },

  getListData ({ commit }) {
    commit('getListDataRequest')
    deliveryTemplateService.getListData(state.all.filter, state.all.currentPage)
      .then(data => {
        commit('getListDataSuccess', data.result)
      })
  },

  getItemsByDeliveryTemplateId ({ commit }, deliveryTemplateId) {
    return deliveryTemplateService.getItemsByDeliveryTemplateId(deliveryTemplateId)
      .then(data => {
        return data.result
      })
  },

  getById ({ commit }, id) {
    return deliveryTemplateService.getById(id)
      .then(data => {
        return data.result
      })
  },

  create ({ commit, dispatch }, deliveryTemplate) {
    commit('startSave')
    return deliveryTemplateService.create(deliveryTemplate)
      .then(deliveryTemplate => {
        commit('endSave')
        commit('createSuccess', deliveryTemplate.result)
        dispatch('getListData')
        return deliveryTemplate.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, deliveryTemplate) {
    commit('startSave')
    return deliveryTemplateService.update(deliveryTemplate)
      .then(deliveryTemplate => {
        commit('endSave')
        commit('updateSuccess', deliveryTemplate.result)
        return deliveryTemplate.result
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('deleteRequest', id)

    deliveryTemplateService.delete(id)
      .then(deliveryTemplate => commit('deleteSuccess', id))
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Get all
  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getAllSuccess (state, data) {
    state.all.items = data.items
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedDeliveryTemplate) {
    Vue.prototype.$toast('Leveransmall skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa leveransmall', 'error')
  },

  // Update
  updateSuccess (state, updatedDeliveryTemplate) {
    state.all.items = state.all.items.map(deliveryTemplate =>
      deliveryTemplate.deliveryTemplateId === updatedDeliveryTemplate.deliveryTemplateId ? updatedDeliveryTemplate : deliveryTemplate
    )

    Vue.prototype.$toast('Leveransmall uppdaterad', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera leveransmall', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to deliveryTemplate being deleted
    state.all.items = state.all.items.map(deliveryTemplate =>
      deliveryTemplate.id === id
        ? { ...deliveryTemplate, deleting: true }
        : deliveryTemplate
    )
  },
  deleteSuccess (state, id) {
    // remove deleted deliveryTemplate from state
    state.all.items = state.all.items.filter(deliveryTemplate => deliveryTemplate.id !== id)
  }
}

export const deliveryTemplates = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/delivery-template.module.js